import { useEffect } from 'react'
import ClientService from '../services/client.service'
import { useTranslation } from "react-i18next";
import { isNullUndefinedOrEmpty } from '../common/Helpers';

const useGetClient = (client_id, setClientInfo) => {  
    useEffect(()=> {

        const getClient = async (clientId) => {

            try {
                let serviceResponse = await ClientService.getClient(clientId);
                const response = serviceResponse.data;
                setClientInfo(response.data)
            }
            catch (error) {
            }
        }

        if (client_id !== null) {
            getClient(client_id)
        }
    
    }, [client_id, setClientInfo]);
}

const useGetAllClient = (clientList, setClientList) => {  
    useEffect(()=> {

        const getClients = async () => {
            try {
                let serviceResponse = await ClientService.getAllClients();
                const response = serviceResponse.data;
                setClientList(response)
            }
            catch (error) {
            }
        }

        if (clientList === null) {
            getClients()
        }
    
    }, [clientList, setClientList]);
}
    
const useGetClientProfileCounters = (client_id, setClientHeaderCounters) => {       
    useEffect(()=> {
        const getData = async (clientId) => {

            try {
                let serviceResponse = await ClientService.getContractAndUserCounts(clientId);
                const response = serviceResponse.data;
                setClientHeaderCounters(response.data);
            }
            catch (error) {
            }
        }

        if (client_id !== null) {
            getData(client_id)
        }
    
    }, [client_id, setClientHeaderCounters]);
}

const useGetAuthRoleUserCounters = (client_id, product_id, counters, setCounters) => {       
    useEffect(()=> {
        const getData = async (clientId, productId) => {

            try {
                let serviceResponse = await ClientService.getUserCountAuthRoles(clientId, productId);
                const response = serviceResponse.data;
                setCounters(response.data);
            }
            catch (error) {
            }
        }

        if (counters === null) {
            getData(client_id, product_id)
        }
    
    }, [counters, client_id, product_id, setCounters]);
}

const useGetSg3RoleUserCounters = (client_id, product_id, user_name, counters, setCounters) => {       
    useEffect(()=> {
        const getData = async (clientId, productId, userName) => {

            try {
                let serviceResponse = await ClientService.getUserCountSg3Roles(clientId, productId, userName);
                const response = serviceResponse.data;
                setCounters(response.data);
            }
            catch (error) {
            }
        }

        if (counters === null && client_id !== null && product_id !== null && user_name !== null) {
            getData(client_id, product_id, user_name)
        }
    
    }, [counters, client_id, product_id, user_name, setCounters]);
}

const useGetProductSuscriptions = (client_id, clientProducts, setProductSuscriptions) => {       
    useEffect(()=> {
        const getData = async (clientId) => {

            try {
                let serviceResponse = await ClientService.getProductSuscriptions(clientId);
                const response = serviceResponse.data;
                setProductSuscriptions(response);
            }
            catch (error) {
            }
        }

        if (clientProducts === null) {
            getData(client_id)
        }
    
    }, [client_id, clientProducts, setProductSuscriptions]);
}

const useGetLegalEntities = (clientId, companyList, setCompanyList, addDefaultSelectItem) => {    

    const { t } = useTranslation();
    
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllCompanies(clientId);
                const response = serviceResponse.data;
    
                if (addDefaultSelectItem) {
                    response.unshift({id: 0, name: t('data-lang-lbl-select')});
                }

                setCompanyList(response);
            }
            catch (error) {
            }
        }
        
        if (companyList === null) {
            getData()
        }
    }, [t, clientId, companyList, setCompanyList, addDefaultSelectItem]);
}

const useGetContracts = (clientId, contracts, setConctracts) => {    

    const { t } = useTranslation();
    
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllContracts(clientId);
                const response = serviceResponse.data;
    
                setConctracts(response);
            }
            catch (error) {
            }
        }
        
        if (contracts === null && clientId !== null && clientId !== "00000000-0000-0000-0000-000000000000") {
            getData()
        }
    }, [t, clientId, contracts, setConctracts]);
}

const useGetClientProducts = (clientId, data, setData) => {        
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllProducts(clientId);
                const response = serviceResponse.data;
    
                setData(response);
            }
            catch (error) {
            }
        }
        
        if (data === null && clientId !== null && clientId !== "00000000-0000-0000-0000-000000000000") {
            getData()
        }
    }, [clientId, data, setData]);
}

const useGetClientProductsToCombobox = (clientId, data, setData) => {        
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllProducts(clientId);
                const response = serviceResponse.data.map(function(item) {
                    return { 
                        key: item.id,
                        text: item.name
                    };
                });
    
                setData(response);
            }
            catch (error) {
            }
        }
        
        if (data === null && clientId !== null && clientId !== "00000000-0000-0000-0000-000000000000") {
            getData()
        }
    }, [clientId, data, setData]);
}

const useGetJobPositionsByUserId = (userId, selectedJobNemo, setSelectedJobId, jobList, setJobList, addDefaultSelectItem) => {    

    const { t } = useTranslation();
    
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllJobsByUserId(userId);
                const response = serviceResponse.data;
    
                if (addDefaultSelectItem) {
                    response.unshift({id: 0, nombre: t('data-lang-lbl-select')});
                }

                setJobList(response);
                setSelectedJobId(response.find(element => element.job_position_nemo === selectedJobNemo).id)
            }
            catch (error) {
            }
        }
        
        if (jobList === null && userId !== null && (selectedJobNemo !== "" && selectedJobNemo !== null)) {
            getData()
        }
    }, [t, userId, selectedJobNemo, setSelectedJobId, jobList, setJobList, addDefaultSelectItem]);
}

const useGetBusinessUnitsByUserId = (userId, selectedAreaNemo, setSelectedAreaId, areaList, setAreaList, addDefaultSelectItem) => {    

    const { t } = useTranslation();
    
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllAreasByUserId(userId);
                const response = serviceResponse.data;

                if (selectedAreaNemo !== null) {
                    const matchedArea = response.find(element => element.business_unit_nemo === selectedAreaNemo);
                    if (matchedArea) {
                        setSelectedAreaId(matchedArea.id)
                    }
                }

                if (addDefaultSelectItem) {
                    response.unshift({id: 0, name: t('data-lang-lbl-select')});
                }
                
                setAreaList(response);
            }
            catch (error) {
            }
        }
        
        if (areaList === null && userId !== null && selectedAreaNemo !== "") {
            getData()
        }
    }, [t, userId, selectedAreaNemo, setSelectedAreaId, areaList, setAreaList, addDefaultSelectItem]);
}

const useGetObservableBusinessUnitsByUserId = (clientId, observableBusinessUnitList, selectedObservableBusinessUnits, setObservableBusinessUnitList) => {       
    useEffect(()=> {

        const getData = async () => {
            try {
                const serviceResponse = await ClientService.getAllBusinessUnitsTree(clientId);
                const response = serviceResponse.data ?? [];

                if (selectedObservableBusinessUnits !== null) {
                    for (const element of selectedObservableBusinessUnits) {
                        // Comparación normalizada (string + trim) para no fallar por
                        // diferencias de tipo/espacios entre el nemo guardado en el
                        // usuario y el nemo que trae el árbol de unidades.
                        const matches = response.filter(element2 => String(element2.nemo).trim() === String(element).trim());

                        if (matches.length === 0) {
                            console.warn(`useGetObservableBusinessUnitsByUserId: no se encontró ninguna unidad de negocio con nemo "${element}" en el árbol recibido.`);
                        }

                        matches.forEach(element2 => { element2.checked = true; });
                    }
                }
                else {
                    for (const element of response) {
                        element.checked = false;
                    }
                }

                const treeData = treeify2(
                    response,
                    'id',
                    'parentId',
                    'children',
                    'code',
                    'name'
                );

                /*treeData.forEach(rootNode => {
                    rootNode.className = "non-selectable-root";
                });*/

                setObservableBusinessUnitList(treeData);
            }
            catch (error) {
                setObservableBusinessUnitList([]);
            }
        }
        
        if (observableBusinessUnitList === null && clientId !== null) {
            getData()
        }
    }, [clientId, observableBusinessUnitList, selectedObservableBusinessUnits, setObservableBusinessUnitList]);
}

const useGetLegalEntitiesByUserId = (userId, selectedLegalEntityNemo, setSelectedCompany, companyList, setCompanyList, addDefaultSelectItem) => {    

    const { t } = useTranslation();
    
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllCompaniesByUserId(userId);
                const response = serviceResponse.data;
    
                if (addDefaultSelectItem) {
                    response.unshift({id: 0, name: t('data-lang-lbl-select')});
                }

                setCompanyList(response);
                setSelectedCompany(response.find(element => element.legal_entity_nemo === selectedLegalEntityNemo))
            }
            catch (error) {
                setCompanyList([]);
            }
        }
        
        if (companyList === null && userId !== null && selectedLegalEntityNemo !== "" && selectedLegalEntityNemo !== null) {
            getData()
        }
    }, [t, userId, selectedLegalEntityNemo, setSelectedCompany, companyList, setCompanyList, addDefaultSelectItem]);
}

const useGetObservableAreas = (clientId, areaList, setAreaList, addDefaultSelectItem) => {    

    const { t } = useTranslation();
    
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllAreas(clientId);
                const response = serviceResponse.data;
    
                if (addDefaultSelectItem) {
                    response.unshift({id: 0, nombre: t('data-lang-lbl-select')});
                }

                setAreaList(response);
            }
            catch (error) {
            }
        }
        
        if (areaList === null && clientId !== null) {
            getData()
        }
    }, [t, clientId, areaList, setAreaList, addDefaultSelectItem]);
}

/*const treeify2 = (
    list,
    idAttr = 'id',
    parentAttr = 'parent',
    childrenAttr = 'children',
    codeAttr,
    nameAttr
) => {
    const treeList = [];
    const lookup = {};

    list.forEach(obj => {
        lookup[obj[idAttr]] = obj;

        obj[childrenAttr] = [];
        obj.value = obj[idAttr];

        if (codeAttr) {
            obj.label = nameAttr
                ? `${obj[codeAttr]}: ${obj[nameAttr]}`
                : `${obj[codeAttr]}: ${obj.name}`;
        }
        else {
            obj.label = nameAttr
                ? `${obj[nameAttr]}`
                : `${obj.name}`;
        }

        // Tipo 1: sin selector.
        // Tipo 2: selector normal.
        obj.className =
            Number(obj.typeId) === 1
                ? "non-selectable-node"
                : "";

        delete obj.disabled;
    });

    list.forEach(obj => {
        const parentId = obj[parentAttr];

        if (
            parentId !== null &&
            lookup[parentId] !== undefined
        ) {
            lookup[parentId][childrenAttr].push(obj);
        }
        else {
            treeList.push(obj);
        }
    });

    return treeList;
};*/

const treeify2 = (
    list,
    idAttr = 'id',
    parentAttr = 'parent',
    childrenAttr = 'children',
    codeAttr,
    nameAttr
) => {
    const treeList = [];
    const lookup = {};

    list.forEach(obj => {
        lookup[obj[idAttr]] = obj;

        obj[childrenAttr] = [];
        obj.value = obj[idAttr];

        if (codeAttr) {
            obj.label = nameAttr
                ? `${obj[codeAttr]}: ${obj[nameAttr]}`
                : `${obj[codeAttr]}: ${obj.name}`;
        }
        else {
            obj.label = nameAttr
                ? `${obj[nameAttr]}`
                : `${obj.name}`;
        }

        // Tipo 1: no seleccionable.
        // Tipo 2: seleccionable.
        obj.className =
            Number(obj.typeId) === 1
                ? "non-selectable-node"
                : "";

        // No usar disabled porque bloquearía también sus descendientes.
        delete obj.disabled;
    });

    list.forEach(obj => {
        const parentId = obj[parentAttr];

        if (
            parentId !== null &&
            lookup[parentId] !== undefined
        ) {
            lookup[parentId][childrenAttr].push(obj);
        }
        else {
            treeList.push(obj);
        }
    });

    return treeList;
};

const treeify = (list, idAttr, parentAttr, childrenAttr) => {
    if (!idAttr) idAttr = 'id';
    if (!parentAttr) parentAttr = 'parent';
    if (!childrenAttr) childrenAttr = 'children';
  
    let treeList = [];
    let lookup = {};
    list.forEach(function(obj) {
        lookup[obj[idAttr]] = obj;
        obj[childrenAttr] = [];
        obj["value"] = obj.id;
        obj["label"] = `${obj.legal_entity_code}: ${obj.name}`;
        obj["tagClassName"] = obj[parentAttr] === null ? "special" : "";
        
    });
    list.forEach(function(obj) {
        if (obj[parentAttr] !== null) {
            if (lookup[obj[parentAttr]] !== undefined) {
                lookup[obj[parentAttr]][childrenAttr].push(obj);
            } else {
                 treeList.push(obj);
            }               
        } else {
            treeList.push(obj);
        }
    });
    return treeList;
};  

const useGetPartyLeBuTree = (clientId, partyArray, setPartyArray) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                const serviceResponse = await ClientService.getAllBusinessUnitsTree(clientId);
                const response = serviceResponse.data ?? [];

                const treeData = treeify2(
                    response,
                    'id',
                    'parentId',
                    'children',
                    'code',
                    'name'
                );

                treeData.forEach(rootNode => {
                    rootNode.className = "non-selectable-root";
                });

                setPartyArray(treeData);
            }
            catch (error) {
                setPartyArray([]);
            }
        };
        
        if (clientId !== null && partyArray === null) {
            getData()
        }
    }, [clientId, partyArray, setPartyArray]);
}

const useGetBusinessUnits = (clientId, businessUnitList, setBusinessUnitList, addDefaultSelectItem) => {    

    const { t } = useTranslation();
    
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllBusinessUnits(clientId);
                let response_aux = serviceResponse.data;

                if (addDefaultSelectItem) {
                    response_aux.unshift({id: 0, name: t('data-lang-lbl-select')});
                }
                else {
                    response_aux = treeify(serviceResponse.data !== null ? serviceResponse.data : [], 'id', 'business_unit_parent_id', 'children')
                }

                const response = response_aux;

                setBusinessUnitList(response);
            }
            catch (error) {
            }
        }
        
        if (businessUnitList === null && clientId !== null) {
            getData()
        }
    }, [t, clientId, businessUnitList, setBusinessUnitList, addDefaultSelectItem]);
}

const useGetJobPositions = (clientId, jobPositionList, setJobPositionList, addDefaultSelectItem) => {    

    const { t } = useTranslation();
    
    useEffect(()=> {

        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getAllJobPositions(clientId);
                const response = serviceResponse.data;
    
                if (addDefaultSelectItem) {
                    response.unshift({id: 0, nombre: t('data-lang-lbl-select')});
                }

                setJobPositionList(response);
            }
            catch (error) {
            }
        }
        
        if (jobPositionList === null && clientId !== null) {
            getData()
        }
    }, [t, clientId, jobPositionList, setJobPositionList, addDefaultSelectItem]);
}

const useGetJobPositionById = (clientId, jobNemo, jobPosition, setJobPosition) => {      
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await ClientService.getJobPosition(clientId, jobNemo);
                const response = serviceResponse.data;
    
                if (!isNullUndefinedOrEmpty(response)) {
                    setJobPosition(response.name);
                }
                else {
                    setJobPosition("S/I");
                }
            }
            catch (error) {
                setJobPosition("S/I");
            }
        }
        
        if (jobPosition === null && clientId !== null && jobNemo !== null) {
            getData()
        }
    }, [ clientId, jobNemo, jobPosition, setJobPosition]);
}

export {
    useGetAllClient,
    useGetClient,
    useGetLegalEntities,
    useGetContracts,
    useGetObservableAreas,
    useGetBusinessUnits,
    useGetPartyLeBuTree,
    useGetJobPositions,
    useGetBusinessUnitsByUserId,
    useGetObservableBusinessUnitsByUserId,
    useGetJobPositionsByUserId,
    useGetLegalEntitiesByUserId,
    useGetClientProfileCounters,
    useGetAuthRoleUserCounters,
    useGetSg3RoleUserCounters,
    useGetProductSuscriptions,
    useGetClientProducts,
    useGetClientProductsToCombobox,
    useGetJobPositionById
}